import { Heading } from 'components/shared/Heading';
import { Texts } from 'components/shared/Texts';
import { FC } from 'react';
import { Button } from 'components/shared/Button';
import styles from './ManualView.module.scss';
import { Decorator } from '../Decorator';

interface ManualViewProps {
  data: {
    header: string;
    desc: Array<string>;
    buttonDesc: string;
  };
  routeTo: () => void;
}

export const ManualView: FC<ManualViewProps> = ({ data, routeTo }) => {
  if (!data) null;

  return (
    <section className={styles.manual_view}>
      <Heading type="h1" className={styles.header}>
        {data.header}
      </Heading>
      <div className={styles.columns}>
        <div className={styles.img_wrapper}>
          <img className={styles.logo} src="/motylek.png" alt="" />
        </div>
        <div className={styles.desc}>
          <Decorator />
          <div className={styles.desc_text}>
            {data.desc.map((desc, i) => {
              return (
                <Texts
                  className={styles.text}
                  key={`ManualText_${i}`}
                  boldPhrase="ostatnich dwóch tygodni"
                >
                  {desc}
                </Texts>
              );
            })}
          </div>
        </div>
      </div>
      <Button className={styles.nextPageNavigation} onClick={() => routeTo()}>
        {data.buttonDesc}
      </Button>
    </section>
  );
};
